export default [{
    path: '/address',
    component: ()=> import("@/views/Address"),
    meta:{
        title:"收货地址"
    },
    children:[]
},
{
    path: '/buy',
    component: ()=> import("@/views/Buy"),
    meta:{
        title:"收货地址"
    },
    children:[]
}]